import React, { useState } from "react";
import Swal from "sweetalert";
import { PiMapPinAreaFill } from "react-icons/pi";
import { GiVibratingSmartphone } from "react-icons/gi";
import { HiOutlineMail } from "react-icons/hi";
import { sendEnquiry } from "../../api/fetch";

export default function ContactUs() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is invalid";
    }

    if (!phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    if (!subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (!message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here (e.g., send email)
    console.log({ name, email, phone, subject, message });

    const isValid = validateForm();
    if (isValid) {
      var formData = {
        fullName: name,
        mobile_number: phone,
        emailAddress: email,
        subject: subject,
        message: message,
      };

      try {
        const res = await sendEnquiry(formData);

        if (res?.status) {
          Swal({
            title: "Success",
            text: res?.msg,
            timer: 3000,
            icon: "success",
          });
          handleClear();
        }
      } catch (error) {
        console.log("Error :", error);
      }
    }
  };

  const handleClear = () => {
    setName("");
    setEmail("");
    setPhone("");
    setSubject("");
    setMessage("");
  };

  return (
    <div className="flex flex-col font-Poppins items-center justify-center">
      <div className="self-center flex w-full lg:py-10 md:py-10 py-3 flex-col items-center justify-center bg-[#fffbee]">
        <h1 className="text-2xl lg:text-4xl font-semibold">Contact Us</h1>
        <img
          src="./assets/border.webp"
          className=" lg:my-6 md:my-4 my-2"
          alt="Header Decoration"
        />
      </div>

      <div className="flex flex-col md:flex-row items-center max-w-7xl gap-10 mt-8 px-4">
        {/* Address Card */}
        <div className="bg-white p-6 flex flex-col items-center space-y-3 w-full sm:w-[400px] h-[200px] justify-center rounded-lg border-2">
          <PiMapPinAreaFill size={"50"} color="#facc15" />
          <h3 className="text-xl font-semibold mb-2">Address</h3>
          <p className="text-gray-600 text-center">
            9/11, Mitralok Colony, Saiyidwala, Khurbura Mohalla, Dehradun,
            Uttarakhand 248001
          </p>
        </div>

        {/* Phone Number Card */}
        <div className="bg-white p-6 flex flex-col items-center w-full sm:w-[400px] h-[200px] justify-center rounded-lg border-2">
          <GiVibratingSmartphone size={"50"} color="#facc15" />
          <h3 className="text-xl font-semibold mb-2">Phone number</h3>
          <p className="text-gray-600 text-center">Phone: +91 757 9126 007</p>
        </div>

        {/* Email Card */}
        <div className="bg-white p-6 flex flex-col items-center w-full sm:w-[400px] h-[200px] justify-center rounded-lg border-2">
          <HiOutlineMail size={"50"} color="#facc15" />
          <h3 className="text-xl font-semibold mb-2">E-mail</h3>
          <p className="text-gray-600 text-center">
            Email: taxicaindia@gmail.com
          </p>
        </div>
      </div>

      {/* Form and Map */}
      <div className="flex flex-col md:flex-row items-center justify-between w-10/12 px-[2%]  mt-10 ">
        {/* <div className=" w-full mr-4 h-[540px]">
          <h2 className="text-2xl font-semibold mb-6">Send us your Enquiry</h2>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  value={phone}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setPhone(value);
                  }}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.phone && (
                  <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="subject"
                  className="block text-sm font-medium text-gray-700"
                >
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.subject && (
                  <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
                )}
              </div>
            </div>

            <div className="mt-4">
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700"
              >
                Your Content
              </label>
              <textarea
                id="message"
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
              ></textarea>
              {errors.message && (
                <p className="text-red-500 text-sm mt-1">{errors.message}</p>
              )}
            </div>

            <button
              type="submit"
              className="mt-6 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Send
            </button>
          </form>
        </div> */}

        <div className=" h-[400px] md:w-[100%] w-[400px] mb-5 md:mt-0 rounded-lg shadow-md overflow-hidden">
          <iframe
            title="map"
            width="100%"
            height="100%"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.011802053702!2d78.035889!3d30.316496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39092972f47b8f77%3A0x2b89b3c18b8d2ff5!2s9%2F11%2C%20Mitralok%20Colony%2C%20Saiyidwala%2C%20Khurbura%20Mohalla%2C%20Dehradun%2C%20Uttarakhand%20248001!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
